<template>
  <div class="admin">

    <h1>Basiseistellungen Event</h1>

    <h1>Schicht erstellen</h1><br>
    <p>Erstelle hier deine Schichten. Falls du die Anzahl Schichtmitarbeiter ändern musst, wähle die selben Einstellungen aus und ändere die Anzahl Arbeiter. </p> <br> <br>

    <form @submit.prevent="saveShift">
      <div class="columns">

        <div class="column is-one-quarter-desktop">
          <h1>Wähle den Tag</h1>
          <div
            v-for="fTag in festivalTage"
            :key="fTag.id"
          >
            <input
              type="radio"
              v-model="FestivalTagAuswahl"
              :value="fTag.festivalTag"
            >{{fTag.festivalTag}}<br>

          </div>
        </div>

        <div class="column is-one-quarter-desktop">
          <h1>Wähle die Zeit</h1>
          <div
            v-for="sZeit in schichtZeiten"
            :key="sZeit.id"
          >
            <input
              type="radio"
              v-model="SchichtZeitAuswahl"
              :value="sZeit.schichtZeit"
            >{{sZeit.schichtZeit}}<br>

          </div>
        </div>

        <div class="column is-one-quarter-desktop">
          <h1> wähle den Einsatzbereich </h1>
          <div
            v-for="sBereich in schichtBereich"
            :key="sBereich.id"
          >
            <input
              type="radio"
              v-model="SchichtBereichAuswahl"
              :value="sBereich"
            >{{sBereich.bereich}}<br>
            <!-- <input type="radio" v-model="SchichtBeschreibungAuswahl"  :value="sBereich.beschreibung" >{{sBereich.beschreibung}}<br> -->
          </div>
        </div>

        <div class="column is-one-quarter-desktop">
          <h1>Anzahl Schichtmitarbeiter</h1>
          <input
            type="number"
            v-model="SchichtmitarbeiterAnzahlAuswahl"
            min="1"
            max="100"
          >
          <br>
          <br>
          <button
            type="submit"
            class="button is-link"
          >Submit</button>

        </div>
      </div>

    </form>
    <br>
    <br>
    <br>

    <div
      class="user-list"
      v-for="schicht in orderBy(orderBy(schichten, 'bereich'), 'tag')"
      :key="schicht.id"
    >
      <div class="columns">
        <div class="column is-8">

          <p class="user-list__header">
            <strong>Tag</strong>: {{schicht.tag}}</p>
          <div class="inner">
            <div class="left">
              <p class="user-list__sub">
                <strong>Zeit</strong>: {{schicht.zeit}}</p>
            </div>
            <div class="right">
              <p class="user-list__sub">
                <strong>Bereich</strong>: {{schicht.bereich}}</p>
            </div>
            <div class="right">
              <p class="user-list__sub">
                <strong>Anzahl</strong>: {{schicht.anzahl}}</p>
            </div>
          </div>
          <button
            class="button is-danger"
            v-on:click="deleteShift(schicht)"
          >Löschen</button>
        </div>
      </div>
    </div>
    <br>
    <br>

  </div>

</template>

<script>
import firebase from 'firebase'
import Vue from 'vue'
import Vue2Filters from 'vue2-filters'
import Moment from 'moment'

Vue.use(Vue2Filters)

export default {
  name: 'admin',
  mixins: [Vue2Filters.mixin],
  data () {
    return {
      schichtBereich: [],
      festivalTage: [],
      schichtZeiten: [],
      schichten: [],
      SchichtBereichAuswahl: '',
      SchichtBeschreibungAuswahl: '',
      FestivalTagAuswahl: '',
      SchichtZeitAuswahl: '',
      SchichtmitarbeiterAnzahlAuswahl: ''

    }
  },

  created () {
    firebase
      .firestore()
      .collection('EventBasicsSchichten')
      .get()
      .then(querySnapshot => {
        this.loading = false
        querySnapshot.forEach(doc => {
          let data = {
            bereich: doc.data().bereich,
            beschreibung: doc.data().beschreibung
          }
          this.schichtBereich.push(data)
        })
      })

    firebase
      .firestore()
      .collection('EventBasicsTage')
      .get()
      .then(querySnapshot => {
        this.loading = false
        querySnapshot.forEach(doc => {
          let data = {
            festivalTag: doc.data().festivalTag
          }
          this.festivalTage.push(data)
        })
      })

    firebase
      .firestore()
      .collection('EventBasicsZeiten')
      .get()
      .then(querySnapshot => {
        this.loading = false
        querySnapshot.forEach(doc => {
          let data = {
            schichtZeit: doc.data().schichtZeit,
            schichtDauer: doc.data().schichtDauer
          }
          this.schichtZeiten.push(data)
        })
      })



    // firebase
    //   .firestore()
    //   .collection("Schichten")
    //   .get()
    //   .then(querySnapshot => {

    //     this.loading = false;
    //     querySnapshot.forEach(doc => {
    //       let data = {
    //         id: doc.id,
    //         tag: doc.data().tag,
    //         zeit: doc.data().zeit,
    //         bereich: doc.data().bereich,
    //         anzahl: doc.data().anzahl
    //       };
    //       this.schichten.push(data);
    //     });
    //   });

    this.getSchichten()
  },

  methods: {
    getSchichten () {
      firebase
        .firestore()
        .collection('Schichten')
        .get()
        .then(querySnapshot => {
          const schichten = []

          this.loading = false
          querySnapshot.forEach(doc => {
            let data = {
              id: doc.id,
              tag: doc.data().tag,
              zeit: doc.data().zeit,
              bereich: doc.data().bereich,
              beschreibung: doc.data().beschreibung,
              anzahl: doc.data().anzahl,
              arbeiter: doc.data().arbeiter
            }
            schichten.push(data)
          })
          this.schichten = schichten
        })
    },

    // saveShift () {
    //   firebase
    //     .firestore()
    //     .doc(
    //       'Schichten/' +
    //       this.FestivalTagAuswahl + ' ' +
    //       this.SchichtZeitAuswahl + ' ' +
    //       this.SchichtBereichAuswahl.bereich
    //     )
    //     .set({
    //       bereich: this.SchichtBereichAuswahl.bereich,
    //       beschreibung: this.SchichtBereichAuswahl.beschreibung,
    //       tag: this.FestivalTagAuswahl,
    //       zeit: this.SchichtZeitAuswahl,
    //       anzahl: this.SchichtmitarbeiterAnzahlAuswahl,
    //       arbeiter: []
    //     })

    //     .then(this.getSchichten)
    //     .then(window.alert('schicht erstellt'))
    // },
    saveShift () {
      let start = Moment(this.SchichtZeitAuswahl.slice(0, 5), 'HH.mm')
      let stop = Moment(this.SchichtZeitAuswahl.slice(8, 13), 'HH.mm')
      if (stop.diff(start, 'h') > 0) {
        let dauer = stop.diff(start, 'h')

        firebase
          .firestore()
          .doc(
            'Schichten/' +
            this.FestivalTagAuswahl + ' ' +
            this.SchichtZeitAuswahl + ' ' +
            this.SchichtBereichAuswahl.bereich
          )
          .set({
            bereich: this.SchichtBereichAuswahl.bereich,
            beschreibung: this.SchichtBereichAuswahl.beschreibung,
            tag: this.FestivalTagAuswahl,
            zeit: this.SchichtZeitAuswahl,
            dauer: dauer,
            anzahl: this.SchichtmitarbeiterAnzahlAuswahl,
            arbeiter: []
          })

          .then(this.getSchichten)
          .then(window.alert('schicht erstellt'))
      } else {
        let dauer = 24 + stop.diff(start, 'h')

        firebase
          .firestore()
          .doc(
            'Schichten/' +
            this.FestivalTagAuswahl + ' ' +
            this.SchichtZeitAuswahl + ' ' +
            this.SchichtBereichAuswahl.bereich
          )
          .set({
            bereich: this.SchichtBereichAuswahl.bereich,
            beschreibung: this.SchichtBereichAuswahl.beschreibung,
            tag: this.FestivalTagAuswahl,
            zeit: this.SchichtZeitAuswahl,
            dauer: dauer,
            anzahl: this.SchichtmitarbeiterAnzahlAuswahl,
            arbeiter: []
          })

          .then(this.getSchichten)
          .then(window.alert('schicht erstellt'))
      }
    },

    deleteShift (schicht) {
      if (schicht.arbeiter.length > 0) {
        var r = confirm('Achtung diese Schicht ist besetzt. Wirklich löschen?')
        if (r === true) {
          firebase
            .firestore()
            .collection('Schichten')
            .doc(schicht.id)
            .delete()
            .then(this.getSchichten)
            .then(window.alert('schicht gelöscht'))
          // eslint-disable-next-line no-console
        } else { console.log('niiicht') }
        // eslint-disable-next-line no-console
        console.log('hatUser')
      } else {
        firebase
          .firestore()
          .collection('Schichten')
          .doc(schicht.id)
          .delete()
          .then(this.getSchichten)
          .then(window.alert('schicht gelöscht'))
      }

      // firebase
      //   .firestore()
      //   .collection('Schichten')
      //   .doc(schicht.id)
      //   .delete()
      //   .then(this.getSchichten)
      //   .then(window.alert('schicht gelöscht'))
    }
  }

  // prevent unauthenticated users from accessing the admin area
  // and direct them to the login page
  // beforeRouteEnter (to, from, next) {
  //   // get the current logged in user
  //   firebase.auth().onAuthStateChanged(user => {
  //     if (user.email === 'moeruw@gmail.com') {
  //       // continue to /admin
  //       next()
  //     } else {
  //       // redirect to /login
  //       next('/login')
  //     }
  //   })
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
